import React from "react";
import "./UpdateDepartmentStyles.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

const UpdateAddDepartmentComponent = (props) => {
  const handleCheckboxChange = (e) => {
    props.handleUseDefaultChange(e);
  };

  const handleDepartmentNameChange = (index, value) => {
    props.handleDepartmentChange(index, 'name', value);
  };

  const handleInitialBalanceChange = (index, value) => {
    props.handleBalanceChange(index, value);
  };

  const handleDefaultBalanceChange = (e) => {
    if (props.handleDefaultBalanceChange) {
      props.handleDefaultBalanceChange(e.target.value);
    }
  };

  const handleAddDepartment = () => {
    if (props.handleAddDepartment) {
      props.handleAddDepartment();
    }
  };

  const handleRemoveDepartment = (index) => {
    if (props.handleRemoveDepartment) {
      props.handleRemoveDepartment(index);
    }
  };

  const getAvailableDepartmentOptions = (currentIndex) => {
    if (!props.availableDepartments || !Array.isArray(props.availableDepartments)) {
      return [];
    }

    return props.availableDepartments.filter(dept => {
      const isSelectedElsewhere = props.departments.some((deptItem, idx) => 
        idx !== currentIndex && deptItem.departmentId === dept.id
      );
      return !isSelectedElsewhere;
    });
  };

  const isLoading = props.loading || props.fetchingDepartments;

  // Prevent wheel scroll and arrow keys on number input
  const preventWheel = (e) => {
    e.preventDefault();
    e.target.blur();
  };

  const preventArrowKeys = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  };

  return (
    <div className="department-setup-container">
      <div className="department-setup-card">
        <Box className="department-setup-box">
          <div className="department-setup-header">
            <h2 className="department-setup-title">Departments</h2>
            <p className="department-setup-subtitle">
              Setup departments & balances
            </p>
          </div>

          <div className="department-checkbox-section">
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.useDefaultDepartment || false}
                  onChange={handleCheckboxChange}
                  className="department-checkbox"
                  disabled={isLoading}
                />
              }
              label="Use Default Department Only"
            />
            <p className="department-checkbox-hint">
              {props.useDefaultDepartment 
                ? "Default balance (wallet) will be applied to all users" 
                : "You can add and configure multiple departments below"}
            </p>
          </div>

          {props.fetchingDepartments && (
            <div className="departments-loading">
              <CircularProgress size={20} style={{ marginRight: "10px" }} />
              <span>Loading departments...</span>
            </div>
          )}

          <div className="department-main-content">
            {props.useDefaultDepartment ? (
              <div className="default-department-section">
                <div className="department-section">
                  <Typography variant="h6" className="department-section-title">
                    DEFAULT SETTINGS
                  </Typography>
                  <p className="default-department-info">
                    When checked, all users will use default department settings
                  </p>
                  
                  <div className="department-fields">
                    <div className="department-field-group">
                      <label className="department-field-label">
                        Default Balance  (₹) *
                      </label>
                      <TextField
                        className="department-balance-input"
                        fullWidth
                        placeholder="Enter default wallet amount (e.g., 1000)"
                        value={props.defaultBalance || ""}
                        onChange={handleDefaultBalanceChange}
                        type="text"
                        disabled={isLoading}
                        inputProps={{
                          inputMode: "decimal",
                          pattern: "[0-9]*\\.?[0-9]*",
                          onWheel: preventWheel,
                          onKeyDown: preventArrowKeys
                        }}
                      />
                    
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="departments-list-container">
                  {props.departments && props.departments.map((dept, index) => (
                    <div key={index} className="department-section">
                      <div className="department-header">
                        <Typography variant="h6" className="department-section-title">
                          DEPARTMENT {index + 1}
                        </Typography>
                        {index !== 0 && !isLoading && (
                          <IconButton
                            onClick={() => handleRemoveDepartment(index)}
                            className="remove-department-button"
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </div>
                      
                      <div className="department-fields">
                        <div className="department-field-group">
                          <label className="department-field-label">
                            Department Name *
                          </label>
                          <FormControl fullWidth className="department-select">
                            <InputLabel>Select department</InputLabel>
                            <Select
                              value={dept.name || ""}
                              onChange={(e) => handleDepartmentNameChange(index, e.target.value)}
                              label="Select department"
                              className="department-select-input"
                              disabled={isLoading}
                            >
                              <MenuItem value="">
                                <em>Select department</em>
                              </MenuItem>
                              {getAvailableDepartmentOptions(index).map(option => (
                                <MenuItem key={option.id} value={option.name}>
                                  {option.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="department-field-group">
                          <label className="department-field-label">
                            Initial Balance  (₹) *
                          </label>
                          <TextField
                            className="department-balance-input"
                            fullWidth
                            placeholder="Enter wallet amount (e.g., 1000)"
                            value={dept.initialBalance || ""}
                            onChange={(e) => handleInitialBalanceChange(index, e.target.value)}
                            type="text"
                            disabled={isLoading}
                            inputProps={{
                              inputMode: "decimal",
                              pattern: "[0-9]*\\.?[0-9]*",
                              onWheel: preventWheel,
                              onKeyDown: preventArrowKeys
                            }}
                          />
                        
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="add-department-section">
                  <Button
                    className="add-department-button"
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={handleAddDepartment}
                    disabled={isLoading}
                  >
                    Add Department
                  </Button>
                </div>
              </>
            )}
          </div>

          {props.loading && (
            <div className="department-loading-indicator">
              <CircularProgress size={24} />
              <span>Processing...</span>
            </div>
          )}
        </Box>
      </div>
    </div>
  );
};

export default UpdateAddDepartmentComponent;